import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import actions from './cart_payment_method.actions';

import type { CheckoutStatus } from 'domains/checkout';
import type { PaymentType } from './cart_payment_method.types';
import type { HostedFieldsTokenizePayload } from 'braintree-web';

type PaymentMethodInitialState = {
  allowNetTerms: boolean;
  hasBraintree: boolean;
  status: CheckoutStatus;
  selectedType: PaymentType | '';
  tokenizePayload?: HostedFieldsTokenizePayload;
  error?: string;
};

const initialState: PaymentMethodInitialState = {
  allowNetTerms: false,
  hasBraintree: true,
  status: 'idle',
  selectedType: '',
};

const slice = createSlice({
  name: 'paymentMethods',
  initialState,
  reducers: {
    resetStatus(state) {
      return { ...state, status: 'idle' };
    },
    setPaymentMethodType(state, { payload }: PayloadAction<PaymentType>) {
      return {
        ...state,
        selectedType: payload,
      };
    },
  },
  extraReducers(builder) {
    builder
      .addCase(actions.getPermissions.fulfilled, (state, { payload }) => {
        const { net_terms, braintree_payments } = payload;
        const defaultPaymentType = net_terms
          ? 'net_terms'
          : braintree_payments
          ? 'credit_card'
          : '';

        return {
          ...state,
          selectedType: defaultPaymentType,
          allowNetTerms: payload.net_terms,
          hasBraintree: payload.braintree_payments,
        };
      })
      .addCase(actions.save.pending, (state) => {
        return { ...state, status: 'pending' };
      })
      .addCase(actions.save.accept, (state) => {
        return { ...state, status: 'success' };
      })
      .addCase(actions.save.fulfilled, (state, { payload }) => {
        return {
          ...state,
          status: 'success',
          tokenizePayload: payload,
        };
      })
      .addCase(actions.save.expire, (state) => {
        return {
          ...state,
          status: 'idle',
          type: '',
          tokenizePayload: undefined,
        };
      })
      .addCase(actions.save.rejected, (state, { payload }) => {
        return {
          ...state,
          status: 'error',
          error: payload,
        };
      });
  },
});

export default slice;
